export function optionone() {
    var option = {
        color: ['#066acd', '#ff8939', '#ecde33'],
        tooltip: {
            trigger: 'axis'
        },
        legend: {
            icon: 'rect',
            itemGap: 21.5,
            left: '3%',
            data: [
                {
                    name: '最大10.00m/s',
                    textStyle: {
                        color: '#066acd'
                    }
                },
                {
                    name: '最小6.00m/s',
                    textStyle: {
                        color: '#ff8939'
                    }
                },
                {
                    name: '平均8.00m/s',
                    textStyle: {
                        color: '#ecde33'
                    }
                }
            ],
            itemHeight: 6, //修改icon图形大小
            itemWidth: 14,
            itemSize: 3,
            textStyle: {
                fontSize: 10,
            },
        },
        grid: {
            left: '3%',
            right: '10%',
            bottom: '3%',
            top: 40,
            containLabel: true
        },

        xAxis: {
            type: 'category',
            axisLabel: {
                show: true,
                textStyle: {
                    color: '#bcdeff', //更改坐标轴文字颜色
                    fontSize: 10 //更改坐标轴文字大小
                }
            },
            //不显示y轴线条
            show: true,
            axisLine: {
                symbol: 'none',
                lineStyle: {
                    color: 'rgba(188,222,255,0.3)', // 颜色
                    width: 2 // 粗细
                }
            },
            splitLine: {
                show: false
            },
            splitLine: {
                show: false
            },
            //不显示刻度
            axisTick: {
                show: false
            },
            boundaryGap: false,
            data: ['3.10', '3.11', '3.12', '3.13', '3.14']
        },
        yAxis: {
            type: 'value',
            max: 100,
            min: 0,
            splitNumber: 5,
            axisLabel: {
                show: true,
                textStyle: {
                    color: '#bcdeff', //更改坐标轴文字颜色
                    fontSize: 10 //更改坐标轴文字大小
                }
            },
            show: true,
            minInterval: 1,
            splitLine: {
                show: false
            },
            //不显示y轴线条
            axisLine: {
                show: false
            },
            //不显示刻度
            axisTick: {
                show: false
            }
        },
        series: [
            {
                name: '最大10.00m/s',
                symbol: 'none',
                type: 'line',
                stack: 'Total',
                smooth: true,
                data: [20, 40, 20, 30, 33, 75, 40]
            },
            {
                name: '最小6.00m/s',
                symbol: 'none',
                type: 'line',
                stack: 'Total',
                smooth: true,
                data: [10, 22, 30, 15, 33, 75, 40]
            },
            {
                name: '平均8.00m/s',
                symbol: 'none',
                type: 'line',
                stack: 'Total',
                smooth: true,
                data: [30, 33, 20, 55, 33, 75, 40]
            }
        ]
    };


    return option

}

export function optiontwo() {
    var demoData = [
        { name: '电压', value: 60, unit: 'V', pos: ['15%', '50%'] },
        { name: '电流', value: 32, unit: 'A', pos: ['46%', '50%'] },
        { name: '电流', value: 32, unit: 'A', pos: ['77%', '50%'] },
    ];

    var option = {
        series: (function () {
            var res = [];
            demoData.forEach(function (item) {
                res.push({
                    type: 'gauge',
                    center: item.pos,
                    radius: '43',
                    axisLine: {
                        lineStyle: {
                            width: 8,
                            color: [
                                [1, '#0e9cff']
                            ]
                        }
                    },
                    pointer: {
                        show: 0,
                        itemStyle: {
                            color: 'auto',
                        }
                    },
                    axisTick: {
                        distance: -15,
                        length: 2,
                        lineStyle: {
                            color: '#fff',
                            width: 1
                        }
                    },
                    splitLine: {
                        distance: -15,
                        length: 8,
                        lineStyle: {
                            color: '#fff',
                            width: 1
                        }
                    },
                    axisLabel: {
                        color: 'auto',
                        distance: 2,
                        fontSize: 6,
                        color: '#fff'
                    },
                    detail: {
                        valueAnimation: true,
                        formatter: '{a|' + item.value + '}{c|\nkm/h}',
                        x: 'center',
                        y: 'center',
                        textStyle: {
                            rich: {
                                a: {
                                    fontSize: 16,
                                    color: '#fff',
                                },

                                c: {
                                    fontSize: 7.45,
                                    color: '#fff',
                                    // padding: [5,0]
                                },
                            },
                        },
                        offsetCenter: [0, '0%'],
                        color: '#fff',
                        fontSize: 10
                    },
                    data: [
                        {
                            value: item.value
                        }
                    ]
                },
                    // 内侧指针、数值显示
                    {
                        name: item.name,
                        type: 'gauge',
                        center: item.pos,
                        radius: '50',
                        startAngle: 225,
                        endAngle: -45,
                        axisLine: {
                            show: true,
                            lineStyle: {
                                width: 16,
                                color: [[1, 'rgba(0, 128, 255,0.2)']]
                            }
                        },
                        axisTick: {
                            show: 0
                        },
                        splitLine: {
                            show: 0
                        },
                        axisLabel: {
                            show: 0
                        },
                        detail: {
                            show: 0
                        }
                    }
                );
            });
            return res;
        })(),
    };
    return option
}